<template >
      <v-row>
        <v-col cols="10" style="padding: 0px !important;">
          <p class="grey--text text--darken-2" style="margin-bottom: 0px !important;">
            <b class="indigo--text" v-if="isMyHandle(chat.handle._id)">{{chat.handle.name}} :</b>
            <b class="pink--text" v-else>{{chat.handle.name}} :</b>
            {{chat.message}}
          </p>
        </v-col>
        <v-col cols="2" style="padding: 0px !important;"> 
          <span style="font-size: 12px;">{{chat.createdAt | moment("DD-MM-YYYY HH:mm")}}</span>
        </v-col>
      </v-row>
</template>

<script>
export default {
  props : ['chat'],
  methods : {
    isMyHandle(handle){
      if (handle == this.$store.getters.HANDLE.handle) {
        return true
      }else{
        return false
      }
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/pages/chat/ChatItem.vue